import { isEmbedMode } from 'v2/shared/utils/embed-session'
import dayjs from 'v2/utils/dayjs'

// Timezone for a new agent. Embed has no profile query and no org timezone, so it uses the
// browser's zone instead of saving `schedule: null`; the console waits for the profile.
export const agentDefaultTimezoneFor = (
  profileTimezone: string | undefined,
  embed: boolean,
  guess: () => string,
): string | undefined => {
  if (profileTimezone) return profileTimezone
  return embed ? guess() : undefined
}

export const agentDefaultTimezone = (profileTimezone: string | undefined): string | undefined =>
  agentDefaultTimezoneFor(profileTimezone, isEmbedMode(), () => dayjs.tz.guess())
